module.exports = __webpack_public_path__ + "img/wb_slide_1.31dff6f9.jpg";